import type { FaireProductEntity } from "../../entity_types/product";

export const p_4cqy6aa49y: FaireProductEntity = {
  token: "p_4cqy6aa49y",
  type: "product",
  name: "Schezwan",
  brandToken: "b_kvtrup43jc",
  brandName: "My Sauce Lab",
  imageUrl:
    "https://cdn.faire.com/fastly/affebedd5d2ecac2cf86bb786d0654ac3754cb60800e0e0e1eba56db82ee12a0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bec70896fe50e45d7ecf1a65b31472e64d03bbcce48dca0f9161c0f5a1ca139b.png",
  ],
  priceDollars: 4.5,
  description:
    "Bold, garlicky, numbing heat straight from the Sichuan pepper tradition. Dried chilies, fresh ginger and garlic, and a splash of soy sauce come together over avocado oil for a sauce that's as much about aroma as it is about fire.\n\nGreat on: stir-fry vegetables, chicken, fried rice, noodles. Great for: cooking in, not just topping with.\n\nIngredients Avocado Oil, Coriander, Dried Peppers, Garlic, Ginger, Onion, Red Chili Powder, Salt, Soy Sauce, Vinegar \nNet Weight 100ML/3.38 FL OZ, 200ML/6.76 FL OZ \nHeat Level 7/10 \nExpiration Date 1 Year From Production \nHow To Use Shake Before Use. Refrigerate After Opening ",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:23.646Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
